import { Action, Module, VuexModule } from "vuex-module-decorators";
import { Medical } from "@/store/enums/StoreEnums";
import ApiService from "@/core/services/ApiService";
import { CookieComponent } from "@/assets/ts/components";

@Module
export default class MedicalModule extends VuexModule {
    @Action
    [Medical.showMedical](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/medical/show`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Medical.listMedical](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/medical/list`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Medical.saveMedical](values, onUploadProgress) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/medical/insert`,values, {headers: {'Content-Type':'multipart/form-data'}, onUploadProgress: onUploadProgress})
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Medical.updateMedical](values, onUploadProgress) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/medical/update`,values, {headers: {'Content-Type':'multipart/form-data'}, onUploadProgress: onUploadProgress})
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Medical.deleteMedical](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/medical/delete`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Medical.uploadMedicalBanner](values, onUploadProgress) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/medical/uploadBanner`,values,{headers: {'Content-Type':'multipart/form-data'}, onUploadProgress: onUploadProgress})
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Medical.uploadArticleImage](values, onUploadProgress) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/medical/uploadArticleImage`,values,{headers: {'Content-Type':'multipart/form-data'}, onUploadProgress: onUploadProgress})
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Medical.removeArticleImage](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/medical/removeArticleImage`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }
}